const navTop = document.querySelector('nav.top.navbar');
const navTopNavbar = navTop ? navTop.querySelector('#navbarNav') : null;
const navTopToggler = navTop ? navTop.querySelector('.navbar-toggler') : null;
const navTopLogoContainer = navTop ? navTop.querySelector('.jsNavbarBrand') : null;
const navTopLogo = navTopLogoContainer ? navTopLogoContainer?.querySelector('img') : null;
const navTopPosition = navTop ? window.getComputedStyle(navTop, null).position : null;
const navTopHeader = document.querySelector('.topHeader');
const megaNav = document.querySelector('.nav-link.dropdown-toggle + .dropdown-menu');
if (navTop) {
  const navItems = document.querySelectorAll('.nav-item:not(.dropdown)');
  const bsCollapse = new bootstrap.Collapse(navTopNavbar, {
    toggle: false
  });
  navItems.forEach(link => link.addEventListener('click', () => bsCollapse.hide()));
  navTopToggler.addEventListener('click', () => {
    if (navTopToggler.classList.contains('collapsed')) {
      navTop.style.overflowY = 'visible';
    } else {
      navTop.style.overflowY = 'scroll';
    }
  });
  if (navTopPosition === "absolute" || navTopPosition === "fixed") {
    bodyMarginTop(navTop);
    window.addEventListener('resize', () => bodyMarginTop(navTop));
  }
  if (navTop.classList.contains('logoBreakFrame')) {
    navTopToggler.addEventListener('click', () => {
      if (navTopToggler.classList.contains('collapsed')) {
        navTopLogo.classList.remove("h-100");
        navTopLogo.classList.add("w-100");
        navTopLogo.style.maxWidth = '100%';
        navTopLogoContainer.style.height = 'auto';
        navTopLogoContainer.style.display = 'inline';
      } else {
        navTopLogo.classList.remove("w-100");
        navTopLogo.classList.add("h-100");
        navTopLogo.style.maxWidth = 'none';
        navTopLogoContainer.style.height = '50px';
        navTopLogoContainer.style.display = 'block';
      }
    });
  }
  if (navTop.classList.contains('mega') && megaNav) {
    let offset = navTop.offsetHeight;
    if (navTopHeader) {
      offset = offset + navTopHeader.offsetHeight;
    }
    megaNav.style.top = `${offset}px`;
    window.addEventListener('resize', () => megaNav.style.top = `${navTop.offsetHeight}px`);
  }
}
function bodyMarginTop(nav) {
  document.body.style.marginTop = `${nav.offsetHeight}px`;
}